import { hmToMin, isoDow, minToHM, nthOfMonth, today } from './dates.js';
import { download } from './messaging.js';
import { invStatus, meetOf, sesAmount, sesEnd, stu, stuName } from './model.js';
import { S, persist } from './state.js';

export function icsEsc(s){return String(s||'').replace(/\\/g,'\\\\').replace(/;/g,'\\;').replace(/,/g,'\\,').replace(/\n/g,'\\n')}
export function icsDT(date,time){return date.replace(/-/g,'')+'T'+time.replace(':','')+'00'}
export function buildICS(){
  const L=['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//Plume//teaching studio//EN','CALSCALE:GREGORIAN'];
  const BY=['MO','TU','WE','TH','FR','SA','SU'];
  for(const r of S.recs){
    if(r.ended)continue;
    const name=stuName(r.studentId);
    let rr='';
    if(r.freq==='monthly'){rr='FREQ=MONTHLY;BYDAY='+nthOfMonth(r.start)+BY[isoDow(r.start)-1]}
    else{const iv=r.freq==='weekly'?1:r.freq==='biweekly'?2:4;rr='FREQ=WEEKLY;INTERVAL='+iv+';BYDAY='+r.days.map(d=>BY[d-1]).join(',')}
    if(r.until)rr+=';UNTIL='+r.until.replace(/-/g,'')+'T235959Z';
    L.push('BEGIN:VEVENT','UID:'+r.id+'@plume','DTSTART:'+icsDT(r.start,r.time),'DTEND:'+icsDT(r.start,minToHM(hmToMin(r.time)+ +r.dur)),'RRULE:'+rr,'SUMMARY:'+icsEsc(name),meetOf(r)?'LOCATION:'+icsEsc(meetOf(r)):'','END:VEVENT');
  }
  for(const s of S.sessions){
    if(s.status==='cancelled')continue;
    L.push('BEGIN:VEVENT','UID:'+s.id+'@plume','DTSTART:'+icsDT(s.date,s.time),'DTEND:'+icsDT(s.date,sesEnd(s)),'SUMMARY:'+icsEsc(stuName(s.studentId)),meetOf(s)?'LOCATION:'+icsEsc(meetOf(s)):'','END:VEVENT');
  }
  L.push('END:VCALENDAR');
  return L.filter(Boolean).join('\r\n');
}
export function parseICS(text){
  const events=[];const lines=text.replace(/\r\n[ \t]/g,'').split(/\r?\n/);
  let cur=null;
  for(const ln of lines){
    if(ln==='BEGIN:VEVENT')cur={};
    else if(ln==='END:VEVENT'){if(cur&&cur.DTSTART)events.push(cur);cur=null}
    else if(cur){
      const i=ln.indexOf(':');if(i<0)continue;
      let key=ln.slice(0,i).split(';')[0],val=ln.slice(i+1);
      cur[key]=val;
    }
  }
  return events.map(e=>{
    const m=String(e.DTSTART).match(/(\d{4})(\d{2})(\d{2})(?:T(\d{2})(\d{2}))?/);
    if(!m)return null;
    const date=m[1]+'-'+m[2]+'-'+m[3];const time=(m[4]?m[4]+':'+m[5]:'12:00');
    let dur=60;
    if(e.DTEND){const me=String(e.DTEND).match(/T(\d{2})(\d{2})/);if(me){dur=(+me[1]*60+ +me[2])-hmToMin(time);if(dur<=0)dur=60}}
    return{date,time,dur,summary:(e.SUMMARY||'').replace(/\\,/g,',').replace(/\\n/g,' '),loc:e.LOCATION||''};
  }).filter(Boolean);
}
export function gcalLink(e){
  const name=stuName(e.studentId);
  const dt=icsDT(e.date,e.time)+'/'+icsDT(e.date,sesEnd(e));
  let u='https://calendar.google.com/calendar/render?action=TEMPLATE&text='+encodeURIComponent(((stu(e.studentId)||{}).subject?stu(e.studentId).subject+' — ':'')+name)+'&dates='+dt;
  if(meetOf(e))u+='&location='+encodeURIComponent(meetOf(e));
  return u;
}

/* ---------- CSV ---------- */
export function csv(rows){return rows.map(r=>r.map(c=>{c=String(c??'');return /[",;\n]/.test(c)?'"'+c.replace(/"/g,'""')+'"':c}).join(';')).join('\n')}
export function exportSessionsCSV(){
  const rows=[['date','time','student','duration_min','status','amount','invoice','recap']];
  const list=[...S.sessions].sort((a,b)=>(a.date+a.time).localeCompare(b.date+b.time));
  for(const s of list){const inv=S.invoices.find(i=>i.id===s.invoiceId);rows.push([s.date,s.time,stuName(s.studentId),s.dur,s.status,sesAmount(s).toFixed(2),inv?inv.no:'',s.summary?'yes':''])}
  download('plume-lessons.csv','\uFEFF'+csv(rows),'text/csv;charset=utf-8');
}
export function exportInvoicesCSV(){
  const rows=[['number','student','issue','due','period','total','status','paid_on','method']];
  for(const i of S.invoices)rows.push([i.no,stuName(i.studentId),i.issue,i.due,i.period,i.total.toFixed(2),invStatus(i),i.paidOn||'',i.method||'']);
  download('plume-invoices.csv','\uFEFF'+csv(rows),'text/csv;charset=utf-8');
}

/* ---------- backup ---------- */
export function exportJSON(){
  S.settings.lastBackup=Date.now();persist();
  download('plume-backup-'+today()+'.json',JSON.stringify(S,null,1),'application/json');
}
